const DIALOG_REGISTRY = require('../dialog.registry');
const {BpmnViewer, IimBpmnViewerConfig, IimBpmnHighlight, IimBpmnHighlightPosition} = require('./BpmnViewer');

class ProcessInstance {
    /**
     * @type {string}
     */
    id;

    /**
     * @type {string}
     */
    definitionId;

    /**
     * @type {ProcessTask[]}
     */
    tasks;

    /**
     * @param dto {ProcessInstance}
     */
    constructor(dto) {
        this.id = dto.id;
        this.definitionId = dto.definitionId;
        this.tasks = dto.tasks.map(task => new ProcessTask(task.taskDefinitionKey));
    }
}

module.exports.ProcessInstance = ProcessInstance;

class ProcessTask {
    /**
     * @type {string}
     */
    taskDefinitionKey;

    constructor(taskDefinitionKey) {
        this.taskDefinitionKey = taskDefinitionKey;
    }
}

class ProcessDisplayDialogData {
    /**
     *
     * @type {ProcessInstance[]}
     */
    processInstances;

    /**
     * @type {string}
     */
    orderNumber;

    /**
     * @type {boolean}
     */
    isOrder;

    /**
     * @type {boolean}
     */
    isPurchaseRequisition;

    constructor(processInstances, orderNumber, isOrder, isPurchaseRequisition) {
        this.processInstances = processInstances;
        this.orderNumber = orderNumber;
        this.isOrder = isOrder;
        this.isPurchaseRequisition = isPurchaseRequisition;
    }
}

module.exports.ProcessDisplayDialogData = ProcessDisplayDialogData;

module.exports.DialogComponent = (app) => app.controller('bpmnDisplayDialog', /* @ngInject */ function ($scope, processDataService, dialogService) {

    /**
     * @type {ProcessDisplayDialogData}
     */
    $scope.data = undefined;

    /**
     * @type {string}
     */
    $scope.xml = '';

    init();

    const config = new IimBpmnViewerConfig();
    $scope.config = config;

    $scope.changeZoomBy = 0.1;
    $scope.currentZoomLevel = 1;
    $scope.moveBy = 30;

    $scope.resetScrollAndZoom = resetScrollAndZoom;
    $scope.zoom = zoom;
    $scope.refresh = refresh;
    $scope.move = move;

    let viewer;
    let currentZoomLevel;

    function init() {
        $scope.data = dialogService.getData(DIALOG_REGISTRY.BPMN_DISPLAY.id);
        if ($scope.data.processInstances) {
            getDataForProcessInstance($scope.data.processInstances[0]);
        } else {
            getDataForProcessDefinition();
        }
    }

    function getDataForProcessInstance(process) {
        this.processInstance = process;
        processDataService.getProcessBpmnXml(process, $scope.data.orderNumber).then((record) => {
            $scope.xml = record.value;
            initViewer();
            $scope.$apply();
        })
    }

    function getDataForProcessDefinition() {
        if ($scope.data.isOrder) {
            processDataService.getBpmnXmlForActiveOrderProcess().then((record) => {
                $scope.xml = record.value;
                initViewer();
                $scope.$apply();
            });
        }
        if ($scope.data.isPurchaseRequisition) {
            processDataService.getBpmnXmlForActivePurchaseRequisitionProcess().then((record) => {
                $scope.xml = record.value;
                initViewer();
                $scope.$apply();
            });
        }
    }

    function initViewer() {
        viewer = new BpmnViewer(config);
        viewer.initialized = () => {
            currentZoomLevel = viewer.canvas.zoom();
        };
        const container = document.getElementById('bpmProcessDisplayContainer');
        container.style.width = config.width;
        container.style.height = config.height;
        if (config.canvasDraggable && config.zoomAndScrollEnabled) {
            container.classList.add('diagram-drag-enabled');
        }
        viewer.attachTo(container);
        if ($scope.xml) {
            viewer.importDiagram($scope.xml).then(() => {
                if ($scope.data.orderNumber) {
                    setHighlights();
                }
            });
        }
    }

    /**
     * Resets the scroll and zoom. Makes the diagram fill the viewport.
     */
    function resetScrollAndZoom() {
        viewer.resetScrollAndZoom();
        $scope.currentZoomLevel = viewer.canvas.zoom();
    }

    /**
     * Re-Initializes the Viewer.
     */
    function refresh() {
        viewer.removeOldHighlights();
        viewer.detach();
        initViewer();
    }

    function zoom(zoomChange) {
        if ($scope.currentZoomLevel + zoomChange > 0) {
            $scope.currentZoomLevel += zoomChange;
            viewer.canvas.zoom($scope.currentZoomLevel);
        }
    }

    function move(dx, dy) {
        viewer.canvas.scroll({
            dx: dx ? dx : 0,
            dy: dy ? dy : 0,
        });
    }

    function setHighlights() {
        const tasks = this.processInstance.tasks;
        if (tasks?.length) {
            const groupedTasks = new Map();
            tasks.forEach((task) =>
                groupedTasks.set(
                    task.taskDefinitionKey,
                    groupedTasks.has(task.taskDefinitionKey) ? groupedTasks.get(task.taskDefinitionKey) + 1 : 1
                )
            );
            const highlights = Array.from(groupedTasks.entries()).map(
                ([key, value]) => new IimBpmnHighlight(key, value)
            );
            for (const highlight of highlights) {
                viewer.highlightTask(highlight);
            }
        }
    }
});
